module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXIV"
    }
  }), _c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/map1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "map1"
    }
  }), _c('b', [_vm._v("Map 1")]), _vm._v(" The central Mediterranean: Carthage, Rome and Sicily")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXV"
    }
  }), _c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/map2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "map2"
    }
  }), _c('b', [_vm._v("Map 2")]), _vm._v(" The western Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXVI"
    }
  }), _c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/map3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "map3"
    }
  }), _c('b', [_vm._v("Map 3")]), _vm._v(" Carthage and environs")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad9fa28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps.vue
// module id = 84
// module chunks = 0